export default function logWarningInDev(condition, msg) {
    if (process.env.NODE_ENV !== 'production') {
        if (condition)
            console.warn(msg);
    }
}
//# sourceMappingURL=logWarningInDev.js.map